/* Animate only product detail tabs; the native controller keeps selection and accessibility. */
(() => {
 const motion=matchMedia('(prefers-reduced-motion: reduce)'),states=new WeakMap(),active=new Set();
 function clean(card){const state=states.get(card);if(!state)return;state.animations.forEach(a=>a.cancel());state.ghost?.remove();states.delete(card);active.delete(card);}
 const capture=event=>{
  if(event.type==='keyup'&&!['Enter','Space'].includes(event.code))return;
  const tab=event.target.closest?.('.vnk-details-card .vnk-details-tab');
  if(!tab||tab.classList.contains('current'))return;
  const card=tab.closest('.vnk-details-card');clean(card);
  if(motion.matches||typeof card.animate!=='function')return;
  const old=card.querySelector('.tab-content.current');if(!old)return;
  const rect=old.getBoundingClientRect(),base=card.getBoundingClientRect();
  const ghost=old.cloneNode(true);ghost.classList.add('vnk-tab-ghost');
  ghost.setAttribute('aria-hidden','true');ghost.inert=true;
  [ghost,...ghost.querySelectorAll('[id]')].forEach(e=>e.removeAttribute('id'));
  ghost.style.cssText=`left:${rect.left-base.left-card.clientLeft}px;top:${rect.top-base.top-card.clientTop}px;width:${rect.width}px;height:${rect.height}px;box-sizing:border-box;`;
  states.set(card,{ghost,from:base.height,animations:[]});active.add(card);
  // If no native tab event is dispatched, release the snapshot on the next frame.
  requestAnimationFrame(()=>{const state=states.get(card);if(state&&!state.animations.length)clean(card);});
 };
 document.addEventListener('click',capture,true);
 document.addEventListener('keyup',capture,true);
 document.addEventListener('theme:tab:change',event=>{
  const card=event.target.matches?.('.vnk-details-card')?event.target:event.target.querySelector?.('.vnk-details-card');
  if(!card)return;const state=states.get(card),panel=card.querySelector('.tab-content.current');
  if(!state||!panel)return;
  const to=card.getBoundingClientRect().height;
  card.append(state.ghost);
  const options={duration:260,easing:'cubic-bezier(.4,0,.2,1)'};
  state.animations=[state.ghost.animate([{opacity:1},{opacity:0}],options),panel.animate([{opacity:0},{opacity:1}],options)];
  if(Math.abs(to-state.from)>1)state.animations.push(card.animate([{height:state.from+'px',overflow:'hidden'},{height:to+'px',overflow:'hidden'}],options));
  Promise.allSettled(state.animations.map(a=>a.finished)).then(()=>{if(states.get(card)===state)clean(card);});
 });
 motion.addEventListener('change',()=>{if(motion.matches)[...active].forEach(clean);});
})();
